import React from 'react';
import PropTypes from 'prop-types';

import { SimpleCheckbox } from 'components/Checkboxes';
import InfoTooltip from 'components/InfoTooltip';
import { PiiFilterHint } from 'store/data/hints';
import FloatingInput from '../FloatingInput';

import {
  Badge,
  BadgeInfo,
  BadgeLabel,
  Description,
  MoreInfoLink,
  OptionHint,
  OptionLabel,
  OptionRow,
  Popup,
  Title,
} from './styles';

const OTHER_DATA_HINT = (
  <>
    E-maile, linki, handle (@nick) oraz inne identyfikatory (PESEL, NIP, numer konta, dowód,
    rejestracja, IP).
  </>
);

const OPTIONS = [
  { key: 'persons', label: 'Imiona i nazwiska', name: 'pii-persons' },
  { key: 'addresses', label: 'Adresy', name: 'pii-addresses' },
  { key: 'phones', label: 'Nr. telefonów', name: 'pii-phones' },
  { key: 'other', label: 'Pozostałe dane', name: 'pii-other', hint: OTHER_DATA_HINT },
];

const PiiFilter = ({ piiFilter, submitUpdatedGlobalConfiguration }) => {
  const handleToggle = (key, value) => {
    submitUpdatedGlobalConfiguration('pii_filter', {
      persons: key === 'persons' ? value : !!piiFilter.persons,
      addresses: key === 'addresses' ? value : !!piiFilter.addresses,
      phones: key === 'phones' ? value : !!piiFilter.phones,
      other: key === 'other' ? value : !!piiFilter.other,
    });
  };

  return (
    <FloatingInput
      text={
        <>
          Ukryj dane osobowe
          <Badge>
            <BadgeLabel>NOWE</BadgeLabel>
            <BadgeInfo>
              <InfoTooltip content={<PiiFilterHint />} placement="right" theme="dark" />
            </BadgeInfo>
          </Badge>
        </>
      }
      popupComponent={
        <Popup>
          <Title>Ukryj dane</Title>
          <Description>
            System inteligentnie ukryje wszelakie wybrane przez Ciebie dane bądź informacje z treści
            donejta od Widza.
          </Description>
          <MoreInfoLink
            href="https://pomoc.tipply.pl/pl/articles/8063460"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sprawdź więcej informacji
          </MoreInfoLink>

          {OPTIONS.map(({ key, label, name, hint }) => (
            <OptionRow key={key}>
              <OptionLabel>
                {label}
                {hint && (
                  <OptionHint>
                    <InfoTooltip content={hint} placement="right" theme="dark" />
                  </OptionHint>
                )}
              </OptionLabel>
              <SimpleCheckbox
                name={name}
                checked={!!piiFilter[key]}
                onCheck={value => handleToggle(key, value)}
                color="green"
                apperance="switch"
              />
            </OptionRow>
          ))}
        </Popup>
      }
    />
  );
};

PiiFilter.propTypes = {
  piiFilter: PropTypes.shape({
    persons: PropTypes.bool,
    addresses: PropTypes.bool,
    phones: PropTypes.bool,
    other: PropTypes.bool,
  }).isRequired,
  submitUpdatedGlobalConfiguration: PropTypes.instanceOf(Function).isRequired,
};

export default PiiFilter;
